<template>
    <div>
      <canvas ref="canvas"></canvas>
    </div>
  </template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import Chart from 'chart.js/auto'

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const canvas = ref(null)
let chartInstance = null

const renderChart = () => {
  if (chartInstance) chartInstance.destroy()
  chartInstance = new Chart(canvas.value, {
    type: 'line',
    data: props.data,
    options: {
      responsive: true,
      maintainAspectRatio: false, // Allow the chart to fill its container
      plugins: {
        legend: {
          display: true,
          labels: {
            color: '#085f63',
            font: {
              weight: 'bold'
            }
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#333'
          }
        },
        y: {
          ticks: {
            color: '#333'
          },
          min: 0
        }
      }
    }
  })
}

const handleResize = () => {
  renderChart()
}

onMounted(() => {
  renderChart()
  window.addEventListener('resize', handleResize)
})

watch(() => props.data, () => {
  renderChart()
}, { deep: true })

onBeforeUnmount(() => {
  if (chartInstance) chartInstance.destroy()
  window.removeEventListener('resize', handleResize)
})
</script>

  <style scoped>
  canvas {
    max-width: 100%;
    width: 100% !important;
    height: 350px !important;
  }
  </style>
